export class ProviderModel {
    constructor(public id: number, public name: string, public isRtb: boolean, public nonConfigurable: boolean, public isFallback: boolean) {
    }
}


// WEBPACK FOOTER //
// ./src/app/core/services/provider.model.ts